// extracted by mini-css-extract-plugin
export var avatar = "expertOpinion-module--avatar--uapQv";
export var blockTitle = "expertOpinion-module--blockTitle--xP7TE";
export var expertOpinionBlock = "expertOpinion-module--expertOpinionBlock--7ucw6";
export var mainContent = "expertOpinion-module--mainContent--qwUrp";
export var person = "expertOpinion-module--person--BbfOi";
export var personName = "expertOpinion-module--personName--4I09l";
export var position = "expertOpinion-module--position--aW8TE";
export var text = "expertOpinion-module--text--KFQj6";